/* eslint-disable eqeqeq */
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API, fileUpload } from "../../config";
import { useStateList, SuburbList } from "../../lib/OptionsAPI";
import {
  formatedPostalCode,
  formatSubcontractorName,
  getModuleNamingBySlug,
  MaxLimit,
} from "../../lib/Misc";
import { AddAssetSchema } from "../../lib/Validation";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";
import CustomLabelText from "../../components/CustomLabelText";
import { Label } from "../../components/ui/label";
import { Loader2 } from "lucide-react";
import { Input } from "../../components/ui/input";
import { CardTitle } from "../../components/ui/card";
import SearchSelect from "../../components/SearchSelect";
import PostalCodeInput from "../../components/PostalCodeInput";
import ProfileUpload from "../../components/ProfileUpload";
import { NumericFormat } from "react-number-format";
import SuburbSelect from "../../components/SuburbSelect";
import { getAssetDetail } from "./AssetHelper";
import Spin from "../../components/Spin";
import VendorSelect from "../../components/VendorSelect";
import { useOrganization } from "../../lib/context/OrganisationContext";
// import { Checkbox } from "../../components/ui/checkbox";
// import Editor from "../../components/Editor";

const AddEditAsset = ({
  edit,
  assetID,
  toggleShowAddEditAsset,
  fetchAssets,
  expandList,
  trustId = "",
}) => {
  const { id } = useParams();
  const { organizationData } = useOrganization();
  const [assetData, setAssetData] = useState();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbListing, setSuburbListing] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const assetId = assetID ? assetID : id;
  const vendorid = localStorage.getItem("vendorId");

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [vendorId, setVendorId] = useState(vendorid);

  const [descriptionValue, setDescriptionValue] = useState("");

  async function fetchData() {
    try {
      setLoading(true);
      const data = await getAssetDetail(assetId);

      if (data?.vendor ? data?.vendor : false) {
        setVendorList([
          data?.vendor
            ? {
                ...data?.vendor,
                value: data?.vendor?.id,
                label: formatSubcontractorName(data?.vendor),
              }
            : {},
        ]);
        setVendorId(data?.vendor?.id);
      }
      if (data?.state_id ? data?.state_id : false) {
        FetchSuburbList(data?.state_id ? data?.state_id : "", "");
        if (data?.suburb_id ? data?.suburb_id : false) {
          setSuburbList([
            data?.suburb
              ? {
                  ...data?.suburb,
                  value: data?.suburb.id,
                  label: data?.suburb.name,
                }
              : {},
          ]);
        }
      }
      if (data?.sub_asset?.description) {
        setDescriptionValue(data?.sub_asset?.description);
      }
      setAssetData(data);
      setLoading(false);
    } catch (e) {
      setAssetData(null);
    }
  }
  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetId]);

  // Submit Form
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";

    value.entity_type = value?.entity_type?.value;

    value.opening_balance = Number(
      `${value?.opening_balance}`.replace(/,/g, "")
    );

    value.estimated_value = Number(
      `${value?.estimated_value}`.replace(/,/g, "")
    );

    formData.append("trust_id", trustId ? trustId : "");

    value?.photo && formData.append("photo", value?.photo ? value?.photo : "");

    formData.append("vendor_id", vendorId ? vendorId : "");
    formData.append("code", value?.code ? value?.code : "");

    formData.append("name", value?.asset_name ? value?.asset_name : "");
    formData.append(
      "estimated_value",
      value?.estimated_value ? value?.estimated_value : ""
    );

    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );

    value?.logo && formData.append("logo", value?.logo ? value?.logo : "");

    formData.append("is_sub_asset", value?.is_sub_asset ? 1 : 0);

    if (value?.is_sub_asset) {
      formData.append(
        "sub_asset_name",
        value?.sub_asset_name ? value?.sub_asset_name : ""
      );
      formData.append(
        "sub_asset_identifier",
        value?.code && value?.identifier ? value?.identifier : ""
      );
      formData.append(
        "sub_asset_description",
        descriptionValue ? descriptionValue : ""
      );
      formData.append(
        "sub_asset_estimated_value",
        value?.estimated_value ? value?.estimated_value : ""
      );

      formData.append(
        "sub_asset_tax_type",
        value?.sub_asset_tax_type ? value?.sub_asset_tax_type : 0
      );

      formData.append(
        "sub_asset_tax_percentage",
        value?.sub_asset_tax_percentage
          ? value?.sub_asset_tax_percentage?.toString()?.replace("%", "")
          : "10"
      );
    }

    if (assetId) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.ASSET_ADD}${assetId ? `/${assetId}` : ""}`,
        formData
      );
      setLoading(false);
      if (data) {
        setDescriptionValue("");
        toggleShowAddEditAsset();
        fetchAssets && fetchAssets();
      }
      return data?.data;
    } catch (error) {
      setAssetData(value);
      setLoading(false);
    }
  };

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) => item?.value === (assetData?.state_id ? assetData?.state_id : "")
  )?.value;

  const FetchSuburbList = async (state_id) => {
    await SuburbList(state_id, 1, setSuburbLoading, setSuburbList, true);
  };

  useEffect(() => {
    if (suburbList) {
      let suburbTempListing = suburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbListing(suburbTempListing || []);
    } else {
      setSuburbListing([]);
    }
  }, [suburbList]);

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  return (
    <Formik
      initialValues={{
        photo: assetData?.photo ? assetData?.photo : "",
        vendor_id: vendorId ? vendorId : "",
        code: assetData?.code ? assetData?.code : "",
        asset_name: assetData?.name ? assetData?.name : "",
        estimated_value: assetData?.estimated_value
          ? assetData?.estimated_value
          : 0,
        street: assetData?.street ? assetData?.street : "",
        postal_code: assetData?.postal_code
          ? formatedPostalCode(assetData?.postal_code)
          : "",
        state_id: state,
        suburb_id: assetData?.suburb_id,
        is_sub_asset: assetData?.is_sub_asset ? true : true,
        sub_asset_name: assetData?.sub_asset?.name
          ? assetData?.sub_asset?.name
          : "",
        identifier: assetData?.sub_asset?.identifier
          ? assetData?.sub_asset?.identifier
          : "",
        sub_asset_tax_type: assetData?.sub_asset?.tax_type
          ? assetData?.sub_asset?.tax_type
          : "0",
        sub_asset_tax_percentage: assetData?.sub_asset?.tax_percentage
          ? assetData?.sub_asset?.tax_percentage
          : "0",
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddAssetSchema(organizationData)}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setTouched,
        validateField,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden max-h-[81vh] p-4 border rounded-lg">
              <div>
                <ProfileUpload
                  path={values?.photo}
                  pathData={values?.asset_name?.charAt(0)}
                  setFieldValue={setFieldValue}
                  keyName={"photo"}
                />
              </div>
              <div className="grid gap-4">
                <CardTitle className="text-md mt-5">
                  {getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "assets",
                    "Asset"
                  )}{" "}
                  Details
                </CardTitle>
                <div className="grid md:grid-cols-2 gap-4">
                  {!expandList && (
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="vendor_id">
                          <CustomLabelText
                            labelText={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor"
                            )}
                            errorField={errors?.vendor_id}
                            required={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <VendorSelect
                            trustId={trustId}
                            frameworkData={vendorListing} // List of vendors
                            optionType={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor"
                            )}
                            handleSelect={(e) => {
                              setVendorId(e);
                              setFieldValue("vendor_id", e);
                            }}
                            name="vendor_id"
                            disabled={false}
                            initialValue={vendorId ? vendorId : ""}
                            setVendorList={setVendorList} // Update vendor list as new data loads
                            setVendorLoading={setVendorLoading} // Control loading state
                            onClear={() => {
                              setVendorId();
                            }}
                            loading={vendorLoading}
                            className={
                              errors?.vendor_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                          {vendorLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="grid gap-2">
                    <Label htmlFor="code">
                      <CustomLabelText
                        required={false}
                        labelText="Code"
                        errorField={errors?.code}
                      />
                    </Label>
                    <Input
                      id="code"
                      type="text"
                      name="code"
                      value={values?.code ? values?.code : ""}
                      onChange={(e) => {
                        setFieldValue("code", e?.target?.value);
                        if (e?.target?.value === "") {
                          setFieldValue("identifier", "");
                        } else {
                          setFieldValue(
                            "identifier",
                            `SBA-${e?.target?.value}`
                          );
                        }
                      }}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.code &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="asset_name">
                      <CustomLabelText
                        required={true}
                        labelText={`${getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "assets",
                          "Asset"
                        )} Name`}
                        errorField={errors?.asset_name}
                      />
                    </Label>
                    <Input
                      id="asset_name"
                      type="text"
                      name="asset_name"
                      value={values?.asset_name ? values?.asset_name : ""}
                      onChange={(e) => {
                        setFieldValue("asset_name", e?.target?.value);
                        setFieldValue(
                          "sub_asset_name",
                          `SBA-${e?.target?.value}`
                        );
                      }}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.asset_name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="estimated_value">
                      <CustomLabelText
                        required={false}
                        labelText="Estimated/Reserved Value($)"
                        errorField={errors?.estimated_value}
                      />
                    </Label>

                    <NumericFormat
                      type="text"
                      name="estimated_value"
                      value={values?.estimated_value}
                      onChange={(e) => {
                        setFieldValue("estimated_value", e?.target?.value);

                        setFieldValue(
                          "sub_asset_estimated_value",
                          e?.target?.value
                        );
                      }}
                      onBlur={handleBlur}
                      decimalScale={2}
                      allowNegative={false}
                      thousandSeparator={true}
                      isAllowed={(values) => MaxLimit(values)}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.estimated_value
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="grid gap-4 pt-4">
                <CardTitle className="text-md">Address</CardTitle>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="street">
                      <CustomLabelText
                        required={false}
                        labelText="Street Address"
                        errorField={errors?.street}
                      />
                    </Label>
                    <Input
                      id="street"
                      placeholder="Enter Street"
                      required
                      name="street"
                      onChange={(e) => {
                        setFieldValue("street", e?.target?.value);
                      }}
                      onBlur={handleBlur}
                      value={values?.street}
                      className={
                        errors?.street &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="state_id">
                      <CustomLabelText
                        required={false}
                        labelText="State"
                        errorField={errors?.state_id}
                      />
                    </Label>
                    <div className="relative">
                      <SearchSelect
                        frameworks={stateListing}
                        optionType={"State"}
                        clearable={true}
                        onClear={() => {
                          setFieldValue("state_id", "");
                          setFieldValue("suburb_id", "");
                          setSuburbList([]);
                        }}
                        handleSelect={(e) => {
                          setFieldValue("state_id", e);
                          setFieldValue("suburb_id", "");
                          setSuburbList([]);
                          FetchSuburbList(e);
                        }}
                        handleBlur={handleBlur}
                        className={
                          errors?.state_id &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={false}
                        initialValue={values?.state_id}
                      />
                      {stateLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="suburb_id">
                      <CustomLabelText
                        required={false}
                        labelText="Suburb"
                        errorField={errors?.suburb_id}
                      />
                    </Label>
                    <div className="relative">
                      <SuburbSelect
                        state_id={values?.state_id} // Pass the selected state ID
                        frameworkData={suburbListing} // List of suburbs
                        loading={suburbLoading}
                        onClear={() => {
                          setFieldValue("suburb_id", "");
                        }}
                        optionType="Suburb"
                        handleSelect={(e) => {
                          setFieldValue("suburb_id", e);
                        }}
                        name="suburb_id"
                        handleBlur={handleBlur}
                        className={
                          errors?.suburb_id &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={values?.state_id ? false : true}
                        initialValue={values?.suburb_id}
                        setSuburbList={setSuburbList} // Update suburb list as new data loads
                        setSuburbLoading={setSuburbLoading} // Control loading state
                      />
                      {suburbLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="postal_code">
                      <CustomLabelText
                        required={false}
                        labelText="Postal Code"
                        errorField={errors?.postal_code}
                      />
                    </Label>
                    <PostalCodeInput
                      id="postal_code"
                      placeholder="Enter Postal Code"
                      required={false}
                      name="postal_code"
                      handleChange={(e) => {
                        setFieldValue("postal_code", e);
                      }}
                      handleBlur={handleBlur}
                      className="justify-start"
                      inputClassName={
                        errors?.postal_code &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                      value={values?.postal_code ? values?.postal_code : ""}
                    />
                  </div>
                </div>
              </div>
              {edit && assetData?.is_sub_asset ? (
                <></>
              ) : (
                <></>
                // <div className="flex items-center space-x-2 mt-4">
                //   <Checkbox
                //     id="terms"
                //     checked={values?.is_sub_asset}
                //     name="same_address"
                //     onClick={() => {
                //       setFieldValue("is_sub_asset", !values?.is_sub_asset);
                //       if (!values?.is_sub_asset) {
                //         setFieldValue(
                //           "sub_asset_name",
                //           `SBA-${values?.asset_name}`
                //         );
                //         setFieldValue(
                //           "sub_asset_estimated_value",
                //           values?.estimated_value
                //         );
                //       } else {
                //         setFieldValue("sub_asset_name", "");
                //         setFieldValue("sub_asset_estimated_value", "");
                //       }
                //     }}
                //   />
                //   <label
                //     htmlFor="terms"
                //     className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                //   >
                //     No{" "}
                //     {getModuleNamingBySlug(
                //       organizationData?.organizationData,
                //       "sub-assets",
                //       "Sub Asset"
                //     )}{" "}
                //     exists for this assset
                //   </label>
                // </div>
              )}
              {/* {values?.is_sub_asset && (
                <div className="grid gap-4">
                  <CardTitle className="text-md mt-5">
                    {getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "sub-assets",
                      "Sub Asset"
                    )}{" "}
                    Details
                  </CardTitle>
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="sub_asset_name">
                        <CustomLabelText
                          required={true}
                          labelText={`${getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "sub-assets",
                            "Sub Asset"
                          )} Name`}
                          errorField={errors?.sub_asset_name}
                        />
                      </Label>
                      <Input
                        id="sub_asset_name"
                        placeholder="Enter Name"
                        required
                        name="sub_asset_name"
                        onChange={(e) => {
                          setFieldValue("sub_asset_name", e?.target?.value);
                        }}
                        disabled
                        onBlur={handleBlur}
                        value={values?.sub_asset_name}
                        className={
                          errors?.sub_asset_name &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="identifier">
                        <CustomLabelText
                          labelText={`${getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "sub-assets",
                            "Sub Asset"
                          )} Identifier`}
                          errorField={errors?.identifier}
                        />
                      </Label>
                      <Input
                        id="identifier"
                        placeholder="Enter Identifier"
                        name="identifier"
                        onChange={(e) => {
                          setFieldValue("identifier", e?.target?.value);
                        }}
                        onBlur={handleBlur}
                        value={values?.identifier}
                        className={
                          errors?.identifier &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="estimated_value">
                        <CustomLabelText
                          required={false}
                          labelText="Estimated/Reserved Value($)"
                          errorField={errors?.estimated_value}
                        />
                      </Label>

                      <NumericFormat
                        type="text"
                        name="estimated_value"
                        disabled
                        value={values?.estimated_value}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        decimalScale={2}
                        allowNegative={false}
                        thousandSeparator={true}
                        isAllowed={(values) => MaxLimit(values)}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.estimated_value
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="sub_asset_tax_type">
                        <CustomLabelText
                          required={true}
                          labelText="GST/VAT Applicable"
                          errorField={errors?.sub_asset_tax_type}
                        />
                      </Label>
                      <div className="relative">
                        <SearchSelect
                          frameworks={taxOptions}
                          optionType={"GST Type"}
                          handleSelect={(e) => {
                            setFieldValue(`sub_asset_tax_type`, e);
                            if (e == "0") {
                              setFieldValue(`sub_asset_tax_percentage`, "0");
                            } else {
                              setFieldValue(`sub_asset_tax_percentage`, "10");
                            }
                            setTimeout(() => {
                              setTouched({ sub_asset_tax_percentage: true });
                              validateField("sub_asset_tax_percentage");
                            }, 0);
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.sub_asset_tax_type &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.sub_asset_tax_type}
                        />
                      </div>
                    </div>

                    <div className="grid gap-2">
                      <Label htmlFor="sub_asset_tax_percentage">
                        <CustomLabelText
                          required={true}
                          labelText="Tax Percentage (%)"
                          errorField={errors?.sub_asset_tax_percentage}
                        />
                      </Label>

                      <NumericFormat
                        type="text"
                        name={`sub_asset_tax_percentage`}
                        value={values?.sub_asset_tax_percentage}
                        onChange={handleChange}
                        onBlur={(e) => {
                          setFieldValue(
                            `sub_asset_tax_percentage`,
                            e?.target?.value
                          );
                        }}
                        decimalScale={2}
                        allowNegative={false}
                        thousandSeparator={true}
                        suffix="%"
                        isAllowed={(values) => MaxLimit(values)}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.sub_asset_tax_percentage
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )
                        }
                      />
                    </div>
                    <div className="grid gap-2 col-span-full">
                      <Label htmlFor="description">
                        <CustomLabelText
                          labelText={`${getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "sub-assets",
                            "Sub Asset"
                          )} Details`}
                          errorField={errors?.description}
                        />
                      </Label>
                      <Editor
                        value={descriptionValue}
                        setValue={setDescriptionValue}
                      />
                    </div>
                  </div>
                </div>
              )} */}
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditAsset();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditAsset;
